export function userFirstNameFormatFilter () {
	return function (user) {
		return user.first_name + ' ' + user.last_name;
	};
}
